<template>
    <div>
        <div class="game-menu">
            <div class="text-screen">
                <div v-if="menu == 'ratio'">
                    <p class="text">Your screen ratio is weird, go fullscreen ?</p>
                    <div class="nav"><a class="link" @click="fullscreenOn()">YES</a>&nbsp;&nbsp;&nbsp;<a class="link"
                            @click="closeMenu()">NO/CLOSE</a></div>
                </div>
                <div v-if="menu == null">
                    <div class="nav nav2">
                        <a class="link" @click="fullscreenOn()">FULLSCREEN</a>
                        <a class="link" @click="toMainConsole()" v-if="$route.path !== '/main-hall'">MAINCONSOLE</a>

                        <div>
                            <a class="link" @click="closeMenu()">CLOSEMENU</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import screenfull from 'screenfull'
    export default {
        name: 'GameMenu',
        data(){
            return{
                mounted: true
            }
        },
          mounted() {
            window.addEventListener("keyup", (e) => this.eventClose(e));
        },
        destroyed(){
            window.removeEventListener("keyup", (e) => this.eventClose(e))
        },
        methods: {
            fullscreenOn(){
                if(screenfull.isEnabled){
                    screenfull.toggle();
                }
            },eventClose(e){
                if (e.key === "Escape") {
                    this.closeMenu();
                }
            },
            closeMenu(){
                this.$emit('closeMenu')
            },
            toMainConsole(){
                this.$emit('closeMenu')
                this.$router.push({name: 'main-hall', params: {origin: 'menu'}})
            }
        },
        props: ['menu'],
    }
</script>

<style lang="scss" scoped>
@import '@/assets/styles/landing-error.scss';

.game-menu{
  position: absolute;
  bottom: 0;
  left: -10px;
  right: -10px;
  z-index: 3;
  background-image: url('../../assets/medias/images/gameMenu.png');
  background-size: 101vw 40vh;
  height: 40vh;
  width: 101vw;
}

.text-screen{
    position: absolute;
      bottom: 0;
  left: 29vw;
  right: 42vw;
    height: 20vh;
}

.text{
    font-size: 5vh;  
    text-align: center;
    margin: 1vh;
}

.nav{
    margin-top: 2vh;
    margin-bottom: 4vh;
}

.nav a{
    font-size: 7vh;
}

.nav2 a {
    font-size: 5vh;
}

</style>